import { ChevronRightIcon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export const CollapsibleSection = ({
  title,
  children,
  defaultOpen = false,
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className={cn(
        'mx-auto w-[70%] rounded-lg border border-secondary bg-primary p-6'
      )}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Text variant="h2">{title}</Text>
        <ChevronRightIcon
          className={cn(
            'h-4 w-4 transition-transform duration-200',
            isOpen && 'rotate-90'
          )}
        />
      </button>
      {isOpen && <div className="pt-3">{children}</div>}
    </div>
  );
};
